/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentClassification = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 1h5.006l.291.283 2.4 2.333.303.295V10h-3v2h6v4h2v6h-6v-6h2v-2H7v1.757l2.364 2.364.707.707-.707.707-2.828 2.829-.707.707-.708-.707-2.828-2.829-.707-.707.707-.707L5 15.414V12h6v-2H8V1zm2 2v5h4V4.756L12.194 3H10zm7 17h2v-2h-2v2zm-11.171.243 1.414-1.415-1.414-1.414-1.415 1.414 1.415 1.415z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDocumentClassification as DocumentClassification };
